/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.assetLibraryModule').service('BulbAssetLibraryGoogleDriveService',
  [
    '$document', '$q', '$translate', '$window', 'BulbErrorService', 'BulbModalService',
    'google', 'ASSET_LIBRARY', 'CONFIG', BulbAssetLibraryGoogleDriveService,
  ]);

function BulbAssetLibraryGoogleDriveService($document, $q, $translate, $window, BulbErrorService, BulbModalService,
                      google, ASSET_LIBRARY, CONFIG) {

  var that = this;

  // if winodow === parent, we are not hosted in an iframe, so 'origin' is normal, but if we are hosted within an
  // iframe, use referrer as the 'origin', as google wants the top level origin.  If we are double nested (iframe
  // within an iframe) this will likely not work because cross-origin security prevents us from accessing
  // information of the hosting pages.
  var origin = (window === parent) ? $window.location.origin : document.referrer;

  var clientId = CONFIG.google.client.id;

  var scope = ['https://www.googleapis.com/auth/drive'];

  var pickerApiLoaded = false;

  var oauthToken = null;
  var oauthCode = null;

  var _pickHandler;

  var googleDriveApiLoaded = false;

  var modalOptions = {
    fontAwesomeCode: 'fab fa-google-drive',
    titleCode: 'assetlibrary_googledoc_permission_heading',
    bodyCode: 'assetlibrary_googledoc_permission_subheading',
    okButtonCode: 'button_update',
    cancelButtonCode: 'button_google_doc_permission_cancel',
    showCancelButton: true,
    windowClass: 'bulb-aero-modal-body bulb-google-doc-modal',
  };

  this.pickerVisibility = false;

  var pickerCallback = function(data) {
    switch(data[window.google.picker.Response.ACTION]){
      case window.google.picker.Action.LOADED:
        that.pickerVisibility = true;
        break;

      case window.google.picker.Action.PICKED:
        that.pickerVisibility = false;
        var doc = data[window.google.picker.Response.DOCUMENTS][0];
        var mimeType = doc[window.google.picker.Document.MIME_TYPE];

        _pickHandler(oauthToken, doc[window.google.picker.Document.ID], mimeType, doc.parentId, doc.url, oauthCode);
        break;

      case window.google.picker.Action.CANCEL:
        that.pickerVisibility = false;
        break;
    }
  };

  var createPicker = function(pickHandler, mimeTypes) {
    _pickHandler = pickHandler;
    if (pickerApiLoaded && oauthToken) {
      var view = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS)
        .setParent('root').setIncludeFolders(true).setEnableDrives(true);

      if (mimeTypes) {
        view.setMimeTypes(mimeTypes);
      }
      return new window.google.picker.PickerBuilder().addView(view).setOrigin(origin)
        .setOAuthToken(oauthToken)
        .hideTitleBar()
        .disableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
        .enableFeature(window.google.picker.Feature.SUPPORT_DRIVES)
        .setCallback(pickerCallback);
    }
  };

  var handleAuthResult = function(authResult) {
    var deferred = $q.defer();
    if (authResult && !authResult.error) {
      /*jshint camelcase: false */
      oauthToken = authResult.access_token;
      oauthCode = authResult.code;
      deferred.resolve();
    } else {
      deferred.reject();
    }
    return deferred.promise;
  };

  var init = function() {
    var deferred = $q.defer();
    oauthToken = null;
    window.gapi.auth.setToken(null);
    window.gapi.auth.signOut();
    window.gapi.auth.authorize({
      'client_id': clientId,
      'scope': scope,
      'response_type': 'code token',
      'immediate': false
    },　function(authResult) {
      handleAuthResult(authResult).then(deferred.resolve);
    });
    return deferred.promise;
  };

    $window.onGoogleAPILoad = function() {
    window.gapi.load('auth');
    window.gapi.load('picker', {
      callback: function() {
        pickerApiLoaded = true;
      }
    });
    //Load the gapi google drive
    if (google.client) {
      google.client.load('drive', 'v2', function() {
        googleDriveApiLoaded = true;
      });
    } else {
      window.gapi.load('client', {
        callback: function() {
          google.client = window.gapi.client;
          window.gapi.client.load('drive', 'v2', function() {
            googleDriveApiLoaded = true;
          });
        }
      });
    }
  };

  this.openImageTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler, ASSET_LIBRARY.FILTER.IMAGE)
        .build().setVisible(true);
    });
  };

  this.openVideoTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler, ASSET_LIBRARY.FILTER.VIDEO).build().setVisible(true);
    });
  };

  this.openAttachedFileTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler).build().setVisible(true);
    });
  };

  this.openAudioTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler, ASSET_LIBRARY.FILTER.AUDIO).build().setVisible(true);
    });
  };

  this.openImageAndVideoTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler, ASSET_LIBRARY.FILTER.IMAGE + ',' + ASSET_LIBRARY.FILTER.VIDEO)
        .build().setVisible(true);
    });
  };

  this.openAllTypePicker = function(pickHandler) {
    init().then(function() {
      createPicker(pickHandler).build().setVisible(true);
    });
  };

  /**
   * Change permission of google doc with anyone link.
   * @param fileId id of google doc.
   * @returns {promise}
   */
  function changePermission (fileId) {
    var deferred = $q.defer();
    var request = google.client.drive.permissions.insert({
      'fileId': fileId,
      'resource': {
        'type': 'anyone',
        'role': 'reader',
        'withLink': true
      }
    });
    request.execute(function (resp) {
      if (resp.code === 404 || resp.code === 403) {
        BulbErrorService.showError($translate.instant('assetlibrary_googledoc_permission_error'), resp);
        deferred.reject(resp);
      }
      deferred.resolve();
    }, function (error) {
      deferred.reject(error);
    });
    return deferred.promise;
  }

  /**
   * Get sharable link of google files if sharable link is not available on picker selection.
   * @param {string} fileId of file which need to add anyoneWithLink permission.
   * @returns {promise}
   */
  this.enableShareableLink = function (fileId) {
    var deferred = $q.defer();

    if (googleDriveApiLoaded && oauthToken && google.client) {
      var checkPermission = google.client.drive.permissions.get({
        'fileId': fileId,
        'permissionId': 'anyoneWithLink'
      });
      checkPermission.execute(function (result) {
        if (result.code === 404) {
          BulbModalService.show(modalOptions).then(function () {
            changePermission(fileId).then(function () {
              var request = google.client.drive.files.get({
                'fileId': fileId
              });
              request.execute(function (resp) {
                var response = {code: oauthCode, url: resp.alternateLink};
                deferred.resolve(response);
              });
            }, function (error) {
              deferred.reject(error);
            });
          });
        } else {
          deferred.resolve();
        }
      }, function (error) {
        deferred.reject(error);
      });
    } else {
      BulbErrorService.showError($translate.instant('google_drive_api_not_loaded'));
    }
    return deferred.promise;
  };

  /**
   * Get sharable link of google doc url if doc is private.
   * @param {string} fileId of file which need to add anyoneWithLink permission.
   * @returns {promise}
   */
  this.getShareableLinkForUrl = function (fileId) {
    var deferred = $q.defer();
    BulbModalService.show(modalOptions).then(function () {
      if (googleDriveApiLoaded && google.client) {
        init().then(function () {
          changePermission(fileId).then(function () {
            var request = google.client.drive.files.get({
              'fileId': fileId
            });
            request.execute(function (resp) {
              var response = {code: oauthCode, url: resp.alternateLink};
              deferred.resolve(response);
            }, function (error) {
              deferred.reject(error);
            });
          }, function (error) {
            deferred.reject(error);
          });
        });
      }
    });
    return deferred.promise;
  };

  {
    var script = $document[0].createElement('script');
    script.src = 'https://apis.google.com/js/api.js?onload=onGoogleAPILoad';
    $document[0].body.appendChild(script);
  }
}


